import { render, staticRenderFns } from "./GatewayWriter.vue?vue&type=template&id=664462b8&"
import script from "./GatewayWriter.vue?vue&type=script&lang=js&"
export * from "./GatewayWriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports